import WithAuth from "../components/hoc/with-auth"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import { Flex, Text, Box, Skeleton } from "@chakra-ui/react"
import FrequentTradesPage from "../components/pages/frequent-trades-page"
import CreateTransactionsForm from "../components/pages/create-transactions-form"
import CreateUserForm from "../components/pages/create-user-form"
import { useQuery } from "react-query"
import { getAllGroups } from "../services/crm.service"
import _ from "lodash"
import ErrorBoundary from "../components/ErrorBoundary"
import ChangePasswordForm from "../components/pages/change-password-form"

const ChangePassword = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar pageTitle="Change Password" pageDesc="User account.">
          <ErrorBoundary>
            <ChangePasswordForm />
          </ErrorBoundary>
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default ChangePassword
